/**
 * Portal API client + tiny localStorage-backed auth context for the
 * customer-portal pages. Token TTL matches the backend (8 hours).
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/portal`;
const STORAGE_KEY = "ec_portal_session";

export function getSession() {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (_) {
        return null;
    }
}

export function setSession(session) {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    } catch (_) {
        /* private mode */
    }
}

export function clearSession() {
    try {
        window.localStorage.removeItem(STORAGE_KEY);
    } catch (_) {
        /* noop */
    }
}

function authHeaders() {
    const s = getSession();
    return s?.token ? { Authorization: `Bearer ${s.token}` } : {};
}

export async function requestMagicLink(email) {
    const { data } = await axios.post(`${API}/auth/request`, { email });
    return data;
}

export async function verifyMagicLink(token) {
    const { data } = await axios.post(`${API}/auth/verify`, { token });
    return data;
}

export async function fetchWhoami() {
    const { data } = await axios.get(`${API}/me`, { headers: authHeaders() });
    return data;
}

export async function fetchDocuments() {
    const { data } = await axios.get(`${API}/documents`, {
        headers: authHeaders(),
    });
    return data;
}

export async function fetchDocumentLink(relativePath) {
    const { data } = await axios.post(
        `${API}/documents/link`,
        { relative_path: relativePath },
        { headers: authHeaders() }
    );
    return data;
}
